import {useMemo} from 'react';
import {useRecoilValue} from 'recoil';

import {languageState} from '_/state/language';

import {AllowedLocaleDateFormats} from '../allowedLocaleDateFormats';

export const useDateLanguageType = (inputLang?: string): string => {
  const userlangState = useRecoilValue(languageState);
  return useMemo(() => {
    if (inputLang === undefined) {
      return userlangState.startsWith('de')
        ? AllowedLocaleDateFormats.DE
        : AllowedLocaleDateFormats.EN;
    }
    return inputLang;
  }, [inputLang, userlangState]);
};
